import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import {
  TStatisticsPortalFilterPayload,
  TStatisticsPortalTableFilterPayload,
} from '../../types/statistics/statistics-portal';
import { TStatisticsPublicStoreState } from '../statisticsPublic/types';
import { STATISTICS_PORTAL_ACTIONS_NAME } from './name';
import { TStatisticsPortalStoreState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getVisitsCountByTimeTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getVisitsCountByTimeTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByTimeTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getVisitsCountByGroupsTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getVisitsCountByGroupsTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByGroupsTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getVisitsCountByUsersTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getVisitsCountByUsersTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByUsersTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getAverageVisitsTimeTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getAverageVisitsTimeTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getAverageVisitsTimeTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getViewsCountByTimeTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getViewsCountByTimeTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getViewsCountByTimeTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getPagesTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getPagesTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getPagesTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getSectionsTable(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getSectionsTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getSectionsTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getUniqueVisitsCountTable(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalTableFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getUniqueVisitsCountTable,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getUniqueVisitsCountTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getViewsCountByTimeChartData(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getViewsCountByTimeChartData,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getViewsCountByTimeChartData),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getUniqueVisitsCountChartData(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getUniqueVisitsCountChartData,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getUniqueVisitsCountChartData),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getAverageVisitsTimeChartData(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getAverageVisitsTimeChartData,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getAverageVisitsTimeChartData),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getVisitsCountByTimeChartData(
  context: ActionContext<TStatisticsPortalStoreState, unknown>,
  payload: TStatisticsPortalFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.portal.getVisitsCountByTimeChartData,
      name: getLocalState(STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByTimeChartData),
      abortController: payload.abortController,
    },
    payload.params,
  );
}
